var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"sticky"}},[(_vm.show)?_c('button-target',{staticClass:"card-sticky-mobile",attrs:{"background":"orange","size":"md","link":_vm.document}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }